import { Theme, ThemeOptions } from '@mui/material';
import material3 from '../material3';

export const getTypographyOverrides = (theme: Theme): ThemeOptions['components'] => {
  return {
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: material3.typography.fontFamily,
          '::-webkit-scrollbar': {
            height: '.5rem'
          },
          '::-webkit-scrollbar-track': {
            background: '#ccc',
            borderRadius: '4px'
          },
          '::-webkit-scrollbar-thumb': {
            background: '#888',
            borderRadius: '6px'
          }
        },
        h1: {
          fontSize: '24px',
          fontWeight: material3.typography.titleWeight,
          letterSpacing: 0,
          color: material3.color.textPrimary,
          [theme.breakpoints.up('md')]: {
            fontSize: '28px'
          }
        },
        h2: {
          fontSize: '18px',
          fontWeight: material3.typography.titleWeight,
          letterSpacing: 0,
          color: material3.color.textPrimary,
          [theme.breakpoints.up('md')]: {
            fontSize: '20px'
          }
        },
        h3: {
          fontSize: '14px',
          fontWeight: material3.typography.titleWeight,
          letterSpacing: 0,
          color: material3.color.textPrimary,
          [theme.breakpoints.up('md')]: {
            fontSize: '18px'
          }
        },
        body1: {
          fontSize: '14px',
          fontWeight: material3.typography.bodyWeight,
          letterSpacing: 0,
          color: material3.color.textPrimary,
          [theme.breakpoints.up('md')]: {
            fontSize: '17px'
          }
        },
        body2: {
          fontSize: '11px',
          fontWeight: material3.typography.bodyWeight,
          letterSpacing: 0,
          color: material3.color.textSecondary,
          [theme.breakpoints.up('md')]: {
            fontSize: '13px'
          }
        }        
      }
    }
  };
};
